import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NeproseService } from 'src/app/services/neprose.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

  constructor( private route: ActivatedRoute, private neproseService: NeproseService, private router: Router, private _sanitizer: DomSanitizer ) { }

  propertyTypes = []

  searchForm: FormGroup

  districtList = []

  backgroundImageURL: any = this._sanitizer.bypassSecurityTrustStyle(`url(${'assets/banner.jpg'})`+` no-repeat fixed center`)

  ngOnInit(): void {
    this.route.data.subscribe((data: { propertyType: any, districtList: any})=>{
      this.propertyTypes = data.propertyType
      this.districtList = data.districtList.districts
    })
    this.neproseService.getBannerImage(1).subscribe(data => {
      if(data.status){
        let banner = data.homeBanner
        this.backgroundImageURL = this._sanitizer.bypassSecurityTrustStyle(`url(${environment.api+'/images/'+banner.imagePath})`+` no-repeat fixed center`)
      }
    })
    this.searchForm = new FormGroup({
      type: new FormControl(null, [Validators.required]),
      district: new FormControl(null),
      keyword: new FormControl(''),
      listingFor: new FormControl(null, [Validators.required]) 
    })
  }

  search(){
    if(this.searchForm.valid){
      if(this.searchForm.value.keyword){
        this.router.navigate(['/search-result/'+this.searchForm.value.type+'/'+this.searchForm.value.listingFor+'/'+this.searchForm.value.keyword])
      }else if(this.searchForm.value.district){
        let district = this.districtList.find(district => district.id == this.searchForm.value.district)
        if(district)
          this.router.navigate(['/search-result/'+this.searchForm.value.type+'/'+this.searchForm.value.listingFor+'/'+district.district])
      }else{
        this.router.navigate(['/properties'])
      }
    }else{
      if(this.searchForm.value.district){
        let district = this.districtList.find(district => district.id == this.searchForm.value.district)
        if(district)
          this.router.navigate(['/location/'+district.district])
      }else if(this.searchForm.value.keyword){
        this.router.navigate(['/location/'+this.searchForm.value.keyword])
      }else{
        this.router.navigate(['/properties'])
      }   
    }
    
  }

}
